import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {ConstantProvider} from './constants.service';


@Injectable({
  providedIn: 'root'
})
export class EmotionReportProvider {
  app: any;

  constructor(public http: HttpClient) {
    this.app = ConstantProvider;
  }

  /**
   * Function that makes a server call to retrieve emotion reports
   *
   * @return
   */
  getEmotionReport(coordinates) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    let filter_emotion;
    let filterCatgeory: string;
    let filterOrganisationSize: string;
    let filterOperationTime: string;
    let filter = '';

    if (sessionStorage.getItem('filter_emotion')) {
      filter_emotion = JSON.parse(sessionStorage.getItem('filter_emotion'));
      if (filter_emotion !== '') {
        filter = '&emotions=' + filter_emotion;
      }
    }

    if (sessionStorage.getItem('filter_category')) {
      filterCatgeory = JSON.parse(sessionStorage.getItem('filter_category'));
      if (filterCatgeory !== '') {
        filter = '&category=' + filterCatgeory;
      }
    }

    if (sessionStorage.getItem('filter_operationTime')) {
      filterOperationTime = JSON.parse(sessionStorage.getItem('filter_operationTime'));
      if (filterOperationTime !== '') {
        filter = '&operationTime=' + filterOperationTime;
      }
    }

    if (sessionStorage.getItem('filter_organisationSize')) {
      filterOrganisationSize = JSON.parse(sessionStorage.getItem('filter_organisationSize'));
      if (filterOrganisationSize !== '') {
        filter = '&organisationSize=' + filterOrganisationSize;
      }
    }

    const projectType = localStorage.getItem('projectType');
    if (projectType) {
      filter = filter + '&projectType=' + projectType;
    } else {
      // @TODO for you-act event
      filter = filter + '&projectType=space';
    }

    if (sessionStorage.getItem('filter_gender')) {
      const filterGender = JSON.parse(sessionStorage.getItem('filter_gender'));
      if (filterGender !== '') {
        filter = filter + '&gender=' + filterGender;
      }
    }
    console.log(filter, 'filter');
    const url = this.app.apiURL + '/api/emotion-reports?lat=' + coordinates.lat + '&long='
      + coordinates.lng + filter;
    return this.http.get(url);
  }

  /**
   * Function that make a server call to retrieve emotion reports for a particular location
   *
   * @return
   */
  getEmotionReportsOfLocation() {
    const url = this.app.API_URL + '/api/emotion-reports?lat=-33.820978&long=151.02341';
    return this.http.get(url);
  }

  /**
   * Function that make a server call to submit emotion report for a location
   *
   * @return
   */
  submitEmotionReport(emotionReport) {
    const url = this.app.API_URL + '/api/emotion-reports';
    return this.http.post(url, emotionReport);
  }

  /**
   * Function that make a server call to update emotion report for a location
   *
   * @return
   */
  updateEmotionReport(id, updateReportObj) {
    const url = this.app.API_URL + '/api/emotion-reports/update/' + id;
    const httpOptions = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(url, updateReportObj, httpOptions);
  }


  /**
   * Function to retrieve the list of reports title
   *
   * @param coordinates
   * @returns
   */
  getEmotionReportList(coordinates) {
    let filter: any = {};

    if (sessionStorage.getItem('filter')) {
      filter = JSON.parse(sessionStorage.getItem('filter'));
    }

    const url = this.app.API_URL + '/api/emotion-reports/list?lat=' + coordinates.lat + '&long='
      + coordinates.lng + '&filter=' + JSON.stringify(filter.data);

    return this.http.get(url);
  }

  /**
   * Function to retrieve the details of a report
   *
   * @param id - id of the report
   * @returns
   */
  getReportDetails(id) {
    const url = this.app.API_URL + '/api/emotion-reports/detail?id=' + id;

    return this.http.get(url);
  }


  /**
   * Function to get the Emotion reports History
   *
   * @param authorizedToken
   * @returns the request url with headers
   */
  getEmotionsReportHistory(authorizedToken) {
    const url = this.app.API_URL + '/api/emotion-reports/history';
    const httpOptions = {
      headers: new HttpHeaders({
        // eslint-disable-next-line @typescript-eslint/naming-convention
        'Content-Type': 'application/json',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        Authorization: 'Bearer ' + authorizedToken
      })
    };
    return this.http.get(url, httpOptions);
  }


  /**
   * Function to remove data required too submit the emotion report from local storage
   */
  removeAddReportDataLocally() {
    localStorage.removeItem('emotions');
    localStorage.removeItem('answers');
    localStorage.removeItem('image');
    localStorage.removeItem('userLocation');
    localStorage.removeItem('locationName');
    localStorage.removeItem('location');
  }

}

